/**
 * Mirrors `DocumentSummary` from backend `ai-agent/summaries/document-summary.types.ts`.
 * Used for AI tool / SSE rendering (SummaryCard, ToolResultCard).
 */
export type DocumentSummaryStatusColor = 'green' | 'amber' | 'red' | 'gray';

export interface DocumentSummary {
  docType: string;
  docId: string;
  title: string;
  status: string;
  statusColor: DocumentSummaryStatusColor;
  keyFacts: { label: string; value: string }[];
  linkedDocs: { type: string; id: string; status: string }[];
  pendingActions: { action: string; owner: string; dueDate?: string }[];
  blockers: { reason: string; resolution: string }[];
  financialImpact?: { label: string; amount: number; currency: string }[];
  nextBestActions: { label: string; toolToCall?: string; navigateTo?: string }[];
  generatedAt: string;
}

export function isDocumentSummary(x: unknown): x is DocumentSummary {
  if (!x || typeof x !== 'object' || Array.isArray(x)) return false;
  const o = x as Record<string, unknown>;
  return (
    typeof o.docType === 'string' &&
    typeof o.docId === 'string' &&
    typeof o.title === 'string' &&
    typeof o.status === 'string' &&
    Array.isArray(o.keyFacts) &&
    Array.isArray(o.linkedDocs) &&
    Array.isArray(o.nextBestActions)
  );
}
